import { Link, useLocation } from 'react-router-dom';
import { categories, getComicById } from '@/mocks/comics';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathname = location.pathname;

  const items: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

  // Category page: /category/:slug
  const categoryMatch = pathname.match(/^\/category\/(.+)$/);
  if (categoryMatch) {
    const slug = categoryMatch[1];
    const category = categories.find((c) => c.slug === slug);
    items.push({ label: category ? `${category.name}漫画` : '分类' });
  }

  // Comic detail page: /comic/:id
  const comicMatch = pathname.match(/^\/comic\/(.+)$/);
  if (comicMatch) {
    const id = comicMatch[1];
    const comic = getComicById(id);
    if (comic) {
      items.push({ label: comic.category, href: `/category/${comic.categorySlug}` });
      items.push({ label: comic.title });
    } else {
      items.push({ label: '漫画详情' });
    }
  }

  // About page
  if (pathname === '/about') {
    items.push({ label: '关于我们' });
  }

  if (items.length <= 1) return null;

  return (
    <nav aria-label="Breadcrumb" className="w-full max-w-[1280px] mx-auto px-4 md:px-6 pt-20 pb-0">
      <ol className="flex items-center gap-1.5 text-sm flex-wrap">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-300 text-xs"></i>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-primary-500 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-800 font-medium' : 'text-foreground-500'}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}